import { useEffect } from 'react';

export default function RobloxRedirect() {
  useEffect(() => {
    const t = setTimeout(() => {
      window.location.replace(
        'roblox://placeId=2534724415&launchData=%7B%22psCode%22%3A%22LACRPSC%22%7D'
      );
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  const handleManualRetry = () => {
    window.location.reload();
  };

  return (
    <>
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          body { margin: 0; padding: 0; overflow: hidden; background: #ffffff; }
        `}
      </style>

      <div
        style={{
          position: 'fixed',
          inset: 0, // Shorthand for top/left/right/bottom: 0
          width: '100vw',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '24px',
          background: '#ffffff',
          fontFamily: 'sans-serif',
          zIndex: 999999,
        }}
      >
        {/* Gray Spinner */}
        <div
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #555555',
            animation: 'spin 1s linear infinite',
          }}
        />

        {/* Text Container */}
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <p
            style={{
              fontSize: '16px',
              fontWeight: 500,
              color: '#444444',
              margin: 0,
            }}
          >
            Joining the private server...
          </p>
          
          <button
            onClick={handleManualRetry}
            style={{
              background: 'none',
              border: 'none',
              color: '#888888',
              fontSize: '13px',
              textDecoration: 'underline',
              cursor: 'pointer',
              padding: '8px',
              transition: 'color 0.2s ease',
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = '#111111')}
            onMouseOut={(e) => (e.currentTarget.style.color = '#888888')}
          >
            Didn't redirect? Click here to retry
          </button>
        </div>
      </div>
    </>
  );
}